import {Component, Input} from '@angular/core';
import {StockItem} from "../../../record/feature-print-models";

@Component({
  selector: 'default-stock-item',
  templateUrl: './default-stock-item.component.html',
  styleUrls: ['./default-stock-item.component.scss']
})
export class DefaultStockItemComponent {

  @Input() stockItem: StockItem | null = null;

}
